import React, {useContext} from "react";
import "./Achievement.scss";
import {achievementSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Achievement() {
  const {isDark} = useContext(StyleContext);
  if (!achievementSection.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="achievements">
        <h1
          className={
            isDark
              ? "dark-mode skills-heading"
              : "skills-heading"
          }
        >
          {achievementSection.title}
        </h1>
        <div className="awards-list">
          {achievementSection.awards.map((award, i) => (
            <div
              key={i}
              className={isDark ? "dark-mode award-item" : "award-item"}
            >
              <span className="award-emoji" role="img" aria-label="award">
                {award.emoji}
              </span>
              <div className="award-content">
                <h3
                  className={
                    isDark ? "dark-mode award-title" : "award-title"
                  }
                >
                  {award.title}
                </h3>
                <p
                  className={
                    isDark
                      ? "dark-mode award-description"
                      : "award-description"
                  }
                >
                  {award.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fade>
  );
}
